import React, { useEffect, useState } from "react";
import { Button, Checkbox, Input, Menu } from "antd";

interface FilterMenuProps {
  title: string;
  options: string[];
  onApply: (vals: string[]) => void;
  onCancel?: () => void;
  styles?: React.CSSProperties;
  selectedOptions?: string[];
  selectedTab?: string;
  search?: boolean;
  showCancel?: boolean; // Add the new prop
}

const FilterMenu: React.FC<FilterMenuProps> = ({
  title,
  options,
  onApply,
  onCancel,
  styles,
  selectedOptions: parentSelectedOptions,
  selectedTab,
  search = false,
  showCancel = true, // Default to true if not provided
}) => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>("");

  useEffect(() => {
    setSelectedOptions(parentSelectedOptions || []);
  }, [parentSelectedOptions]);

  const handleCheckboxChange = (option: string) => {
    setSelectedOptions((prevSelected) => {
      if (prevSelected.includes(option)) {
        return prevSelected.filter((item) => item !== option);
      } else {
        return [...prevSelected, option];
      }
    });
  };

  const filteredOptions = options.filter((option) =>
    option.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="drop-down-demo" style={{ ...styles }}>
      <Menu>
        <Menu.ItemGroup>
          <h4 className="table-heading">{title}</h4>

          {search && (
            <div
              style={{
                paddingLeft: "4px",
                paddingRight: "4px",
                paddingTop: "4px",
                paddingBottom: "4px",
              }}
            >
              <Input
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  width: "100%",
                  height: "32px",
                  fontSize: "0.875rem",
                }}
                size="small"
              />
            </div>
          )}

          <div
            style={{
              maxHeight: "220px",
              overflow: "auto",
            }}
          >
            {filteredOptions.map((option, index) => (
              <Menu.Item key={index}>
                <div onClick={(e) => e.stopPropagation()} className="ml-5">
                  <Checkbox
                    className="status-checkboxes"
                    checked={selectedOptions.includes(option)}
                    onChange={() => handleCheckboxChange(option)}
                  >
                    {option}
                  </Checkbox>
                </div>
              </Menu.Item>
            ))}
            {search && filteredOptions.length === 0 && (
              <div className="text-center text-gray-500 p-2">No options found</div>
            )}
          </div>
        </Menu.ItemGroup>
        <Menu.Divider />
        <Menu.Item>
          <div className="dropdown-actions">
            {showCancel && ( // Conditionally render the "Cancel" button
              <Button className="dash-outline" onClick={onCancel}>
                Cancel
              </Button>
            )}
            <Button className="dash" onClick={() => onApply(selectedOptions)}>
              Apply
            </Button>
          </div>
        </Menu.Item>
      </Menu>
    </div>
  );
};

export default FilterMenu;
